import {
	HOMEPAGE_DATA_REQUEST,
	HOMEPAGE_DATA_SUCCESS,
	HOMEPAGE_DATA_ERROR,
	GET_SECTION_GAMES_REQUEST,
	GET_SECTION_GAMES_SUCCESS,
	GET_SECTION_GAMES_ERROR,
	GET_SECTION_GAMES_UNCHANGED,
	ALL_CATEGORY_DATA_LOADED,
	HOMEPAGE_DATA_RESET,
	HOMEPAGE_DATA_UNCHANGED,
} from "../actions/homeActions";
import { CONTENT_SCOPE_CHANGED } from "../actions/contentCacheActions";

const initialState = {
	contentUserScope: null,
	loading: false,
	refreshing: false,
	loaded: false, //To Check Home page Games listing data loaded or not.
	config: {},
	categoryList: [], //Game Category List Array for home page carousel only
	featured: [],
	sections: [], // To display games section wise on Home page
	activeSectionViewAll: [], //Used to display section games view all page games,
	sectionLoading: {}, // Tracks concurrent section requests independently.
	sectionRefreshing: {},
	allCategoryDataLoaded: false, // Used to restrict Categorywise API call multiple time
};

export const HomeReducer = (state = initialState, action) => {
	switch (action.type) {
		case CONTENT_SCOPE_CHANGED:
			return { ...initialState, contentUserScope: action.userScope };
		case HOMEPAGE_DATA_RESET:
			return {
				...state,
				loaded: false,
			};
		case HOMEPAGE_DATA_REQUEST:
			return {
				...state,
				loading: !state.loaded,
				refreshing: state.loaded,
			};
		case HOMEPAGE_DATA_SUCCESS:
			if (state.contentUserScope && action.userScope && state.contentUserScope !== action.userScope) {
				return state;
			}
			return {
				...state,
				loading: false,
				refreshing: action?.source === "cache",
				categoryList: action?.payload?.categories,
				featured: action?.payload?.featured,
				sections: action?.payload?.sections,
				loaded: true,
				config: action?.payload?.config,
			};
		case HOMEPAGE_DATA_UNCHANGED:
			return {
				...state,
				loading: false,
				refreshing: false,
			};
		case HOMEPAGE_DATA_ERROR:
			return {
				...state,
				loading: false,
				refreshing: false,
			};
		case GET_SECTION_GAMES_REQUEST:
			{
				const sectionId = action?.payload?.section_id;
				return {
					...state,
					loading: state.activeSectionViewAll.length === 0,
					sectionLoading: sectionId == null ? state.sectionLoading : {
						...state.sectionLoading,
						[sectionId]: true,
					},
					sectionRefreshing: sectionId == null ? state.sectionRefreshing : {
						...state.sectionRefreshing,
						[sectionId]: false,
					},
				};
			}
		case GET_SECTION_GAMES_SUCCESS:
			{
			if (state.contentUserScope && action.userScope && state.contentUserScope !== action.userScope) {
				return state;
			}
			const sectionId = action?.payload?.id ?? String(action?.requestKey || "").split(":").at(-1);
			if (!action?.payload || sectionId == null || sectionId === "") {
				return { ...state, loading: false };
			}
			let sectionsItemArr = [...state.activeSectionViewAll];
			let sectionDataIndex = sectionsItemArr.findIndex(
				(x) => Number(x.id) === Number(sectionId)
			);
			if (sectionDataIndex >= 0) {
				sectionsItemArr[sectionDataIndex] = action.payload;
			} else {
				sectionsItemArr.push(action.payload);
			}
			return {
				...state,
				loading: false,
				activeSectionViewAll: sectionsItemArr,
				sectionLoading: {
					...state.sectionLoading,
					[sectionId]: false,
				},
				sectionRefreshing: {
					...state.sectionRefreshing,
					[sectionId]: action?.source === "cache",
				},
			};
			}
		case GET_SECTION_GAMES_UNCHANGED:
			{
				if (state.contentUserScope && action.userScope && state.contentUserScope !== action.userScope) {
					return state;
				}
				const sectionId = String(action?.requestKey || "").split(":").at(-1);
				return {
					...state,
					loading: false,
					sectionLoading: { ...state.sectionLoading, [sectionId]: false },
					sectionRefreshing: { ...state.sectionRefreshing, [sectionId]: false },
				};
			}
		case GET_SECTION_GAMES_ERROR:
			{
			const sectionId = String(action?.requestKey || "").split(":").at(-1);
			return {
				...state,
				loading: false,
				sectionLoading: !sectionId ? state.sectionLoading : {
					...state.sectionLoading,
					[sectionId]: false,
				},
				sectionRefreshing: !sectionId ? state.sectionRefreshing : {
					...state.sectionRefreshing,
					[sectionId]: false,
				},
			};
			}
		case ALL_CATEGORY_DATA_LOADED:
			return {
				...state,
				allCategoryDataLoaded: true,
			};
		default:
			return state;
	}
};
